import React from 'react';
import MainHeader from '../MainHeader';
import { browserHistory } from 'react-router';
import Storage from '../../Storage';

const MAX_TABLE_HEIGHT = 500;

class BaseLayout extends React.Component {
  static calcTableHeight(list) {
    let height = (list.length + 1) * 50;
    if (height <= MAX_TABLE_HEIGHT) return height;
    return MAX_TABLE_HEIGHT;
  }

  navigateTo(tabName) {
    let pathForTab = Storage.getTabPathname(tabName) || '/' + tabName;
    switch (tabName) {
      case 'kiosk':
        pathForTab = Storage.getTabPathname(tabName) || '/kiosk/all';
        break;
      case 'server':
        pathForTab = Storage.getTabPathname(tabName) || '/server/all';
        break;
      case 'app':
        pathForTab = Storage.getTabPathname(tabName) || '/app/status';
        break;
      case 'user':
        pathForTab = Storage.getTabPathname(tabName) || '/user/all';
        break;
      case 'admin':
        pathForTab = Storage.getTabPathname(tabName) || '/admin/';
        break;
    }
    browserHistory.push(pathForTab);
  }

  render() {
    let {
      auth: { user },
    } = this.props;
    let tabClassName = 'header-tabs__tab';
    let selectedTabClassName = 'header-tabs__tab header-tabs__tab--selected';
    let tabWidthPercent = '33.33%'; // 3 tabs for normal role
    let isSuperRole = user && user.isSuperRole();
    if (isSuperRole) {
      // tabWidthPercent = '25%'; // 4 tabs for super role
      tabWidthPercent = '20%'; // 5 tabs for super role
    }

    return (
      <div className='container'>
        <MainHeader {...this.props} />
        <div className='header-tabs'>
          <ul className=''>
            <li
              className={
                this.props.selectedTabName === 'kiosk' ? selectedTabClassName : tabClassName
              }
              style={{ width: tabWidthPercent }}
              ref='kiosk'
              onClick={this.navigateTo.bind(this, 'kiosk')}
            >
              <i className='fa fa-fw fa-desktop' />
              Kiosk
            </li>
            <li
              className={
                this.props.selectedTabName === 'server' ? selectedTabClassName : tabClassName
              }
              style={{ width: tabWidthPercent }}
              ref='server'
              onClick={this.navigateTo.bind(this, 'server')}
            >
              <i className='fa fa-fw fa-server' />
              Server
            </li>
            <li
              className={this.props.selectedTabName === 'app' ? selectedTabClassName : tabClassName}
              style={{ width: tabWidthPercent }}
              ref='app'
              onClick={this.navigateTo.bind(this, 'app')}
            >
              <i className='fa fa-fw fa-list-alt' />
              Application
            </li>
            {isSuperRole && (
              <li
                className={
                  this.props.selectedTabName === 'user' ? selectedTabClassName : tabClassName
                }
                style={{ width: tabWidthPercent }}
                ref='user'
                onClick={this.navigateTo.bind(this, 'user')}
              >
                <i className='fa fa-fw fa-list' />
                User
              </li>
            )}
            {isSuperRole && (
              <li
                className={
                  this.props.selectedTabName === 'admin' ? selectedTabClassName : tabClassName
                }
                style={{ width: tabWidthPercent }}
                ref='admin'
                onClick={this.navigateTo.bind(this, 'admin')}
              >
                <i className='fa fa-fw fa-adjust' />
                Admin
              </li>
            )}
          </ul>
        </div>

        <div style={this.props.style}>{this.props.children}</div>
      </div>
    );
  }
}

export default BaseLayout;



// WEBPACK FOOTER //
// ./src/components/pages/BaseLayout.js